import RangeFilter, { createRangeFilterTemplate } from '@/filters/Range';
import { createFormatter } from '@/filters/Range/utils';

export const createUserAgeFilter = createRangeFilterTemplate({
  FormatComponent: createFormatter({ unit: 'лет' }),
});

export default RangeFilter;
